import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'app/components/components.module';
import { ArticleComponent } from './article.component';
import { ArticleRoute } from './article.routing';
import { PipeModule } from '@shared/pipe/pipe.module';
import { TinyReplacerService } from '@shared/services/tinyReplacer.service';

@NgModule({
  declarations: [ArticleComponent],
  imports: [
    CommonModule,
    ArticleRoute,
    ComponentsModule,
    TranslateModule,
    PipeModule,
  ],
  providers: [TinyReplacerService]
})
export class ArticleModule {}
